import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Sarah M.",
    location: "Indianapolis, IN",
    rating: 5,
    text: "I've wanted to try GLP-1 but it seemed really expensive, I started at $74/month which fits my budget, and the telehealth consults made it so easy. Down 35 lbs in 4 months!",
    highlight: "Down 35 lbs in 4 months",
  },
  {
    name: "Marcus T.",
    location: "Knoxville, TN",
    rating: 5,
    text: "I was paying $550/month elsewhere for tirzepatide. Switched to HillaryRx and now pay $299/month with personalization. The virtual consultations and check-ins are convenient and the shipping is always on time.",
    highlight: "Saving $250/month",
  },
  {
    name: "Jennifer L.",
    location: "Augusta, GA",
    rating: 5,
    text: "Finally, a weight loss program that doesn't require insurance hoops. The 3-month starter program was perfect. My energy is up, cravings are gone, and I feel like myself again.",
    highlight: "No insurance hassles",
  },
];

const TrueWellnessTestimonials = () => {
  return (
    <section className="py-16 md:py-24 bg-[#181818]">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-4 py-2 bg-emerald-500/10 text-emerald-400 font-semibold rounded-full text-sm mb-4">
              Real Results
            </span>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-4">
              What Our <span className="text-emerald-400">Patients</span> Say
            </h2>
            <p className="text-lg sm:text-xl text-emerald-100/70 max-w-2xl mx-auto">
              Join thousands who've transformed their health with affordable GLP-1 weight loss programs.
            </p>
          </div>

          {/* Testimonials Grid */}
          <div className="grid md:grid-cols-3 gap-6 md:gap-8">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="relative bg-emerald-900/30 border border-emerald-700/30 rounded-2xl p-6 md:p-8 backdrop-blur-sm hover:bg-emerald-900/40 transition-all duration-300 group"
              >
                {/* Quote Icon */}
                <div className="absolute -top-4 left-6">
                  <div className="w-8 h-8 bg-emerald-500 rounded-full flex items-center justify-center">
                    <Quote className="w-4 h-4 text-white" />
                  </div>
                </div>

                {/* Stars */}
                <div className="flex gap-1 mb-4 mt-2">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>

                {/* Testimonial Text */}
                <p className="text-emerald-100/80 leading-relaxed mb-6 text-sm md:text-base">
                  "{testimonial.text}"
                </p>

                {/* Highlight Badge */}
                <div className="inline-block px-3 py-1.5 bg-emerald-500/20 border border-emerald-500/30 rounded-full mb-6">
                  <span className="text-emerald-400 font-semibold text-sm">
                    ✓ {testimonial.highlight}
                  </span>
                </div>

                {/* Author */}
                <div className="flex items-center gap-3 pt-4 border-t border-emerald-700/30">
                  <div className="w-10 h-10 bg-gradient-to-br from-emerald-400 to-emerald-600 rounded-full flex items-center justify-center">
                    <span className="text-white font-bold text-sm">
                      {testimonial.name.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <p className="text-white font-semibold text-sm">{testimonial.name}</p>
                    <p className="text-emerald-400/70 text-xs">{testimonial.location}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Disclaimer */}
          <p className="text-center text-emerald-100/50 text-xs mt-10 max-w-2xl mx-auto">
            *Individual results may vary. Testimonials reflect personal experiences and are not guaranteed outcomes. 
            Compounded medications are not FDA-approved. Consult a licensed provider before starting any weight loss program.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TrueWellnessTestimonials;
